import React, { useContext } from "react";
import { useQuery } from "react-query";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { Pagination, Card } from "antd";
import { userContext } from "../../context/UserContextProvider";
import MedicalCampTable from "./MedicalCampTable";

const MedicalCampList = () => {
  const axiosInstance = useAxiosInstance();
  const { currentPage, setCurrentPage, limit, setLimit, total, setTotal } =
    useContext(userContext);

  // Always set limit to 1000
  React.useEffect(() => {
    setLimit(1000);
  }, [setLimit]);

  const fetchMedicalCamps = async () => {
    const response = await axiosInstance.get(
      `/api/medicalCamp?page=${currentPage}&limit=1000`
    );
    setTotal(response?.data?.data?.totalCamps); // total records count from backend
    return response.data.data;
  };

  const { data } = useQuery(["medicalCamp", currentPage], fetchMedicalCamps);

  return (
    <>
      {/* 🔹 Card showing total records */}
      <div className="mb-4 mx-5">
        <Card className="shadow-md rounded-lg flex flex-col justify-center items-center">
          <h3 className="text-lg font-semibold">Total Medical Camp Records</h3>
          <p className="text-2xl font-bold text-center">{total || 0}</p>
        </Card>
      </div>

      <MedicalCampTable data={data?.results || []} />

      <div className="client-pagination mx-5 mt-4">
        <Pagination
          current={currentPage}
          pageSize={1000}
          total={total}
          showSizeChanger={false}
          onChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default MedicalCampList;
